var map = {
	"./beverages.svg": "5727",
	"./fan.svg": "deee",
	"./glasses.svg": "f112",
	"./index.svg": "9c7a",
	"./set.svg": "1576",
	"./ship.svg": "03de",
	"./watermelon.svg": "9132"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";